export default class AppraisalOperation {
  setOperationNumber(value) {
    if (!value) throw new Error('invalid operationNumber');
    this.operationNumber = value;
    return this;
  }

  setRut(value) {
    this.rut = value;
    return this;
  }

  setClientName(value) {
    this.clientName = value;
    return this;
  }

  setSegment(value) {
    this.segment = value;
    return this;
  }

  setPropertySalePrice(value) {
    this.propertySalePrice = value;
    return this;
  }

  setSubsidy(value) {
    this.subsidy = value;
    return this;
  }

  setAppraisedValue(value) {
    this.appraisedValue = value;
    return this;
  }

  setAnnualEmissionRate(value) {
    this.annualEmissionRate = value;
    return this;
  }

  setMonthlyIssuanceRate(value) {
    this.monthlyIssuanceRate = value;
    return this;
  }

  setTermInMonths(value) {
    this.termInMonths = value;
    return this;
  }

  setMonthsOfGrace(value) {
    this.monthsOfGrace = value;
    return this;
  }

  setLtv(value) {
    this.ltv = value;
    return this;
  }

  setAmountAwarded(value) {
    this.amountAwarded = value;
    return this;
  }

  setShareValue(value) {
    this.shareValue = value;
    return this;
  }

  setLastInstallmentValue(value) {
    this.lastInstallmentValue = value;
    return this;
  }

  setSpread(value) {
    this.spread = value;
    return this;
  }

  setAnnualEndorsementFee(value) {
    this.annualEndorsementFee = value;
    return this;
  }

  setMonthlyEndorsementFee(value) {
    this.monthlyEndorsementFee = value;
    return this;
  }

  setSubscriptionDate(value) {
    this.subscriptionDate = value;
    return this;
  }

  setPeriodOfFirstContribution(value) {
    this.periodOfFirstContribution = value;
    return this;
  }

  setEndorsementDate(value) {
    this.endorsementDate = value;
    return this;
  }

  setDateOfFirstContributionToEndorse(value) {
    if (!value) throw new Error('invalid dateOfFirstContributionToEndorse');
    this.dateOfFirstContributionToEndorse = value;
    return this;
  }

  setDateOfLastContribution(value) {
    this.dateOfLastContribution = value;
    return this;
  }

  setNumberOfInstallmentsToEndorse(value) {
    this.numberOfInstallmentsToEndorse = value;
    return this;
  }

  setVANEndorsementDate(value) {
    this.VANEndorsementDate = value;
    return this;
  }

  setWarrantyDirection(value) {
    this.warrantyDirection = value;
    return this;
  }

  setCommune(value) {
    this.commune = value;
    return this;
  }

  setOverduePayments(value) {
    if (Number.isNaN(value) || value < 0) {
      throw new Error('invalid overduePayments');
    }
    this.overduePayments = value;
    return this;
  }

  setCity(value) {
    this.city = value;
    return this;
  }

  setNotary(value) {
    this.notary = value;
    return this;
  }
}
